import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, ReactiveFormsModule } from "@angular/forms";
import {MatDialogRef} from "@angular/material/dialog";
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { MatIcon } from '@angular/material/icon';
import { MatLabel } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';


@Component({
    selector: 'app-manage-placeholder',
    templateUrl: './manage-placeholder.component.html',
    styleUrls: ['./manage-placeholder.component.scss'],
    imports: [ReactiveFormsModule, MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatIcon, MatLabel, MatSelect, MatOption]
})
export class ManagePlaceholderComponent implements OnInit {

savingInProgress: boolean=false;
    isUserCanEdit: any;
  isCancelling: any;
  isSaving: any;
  isFormDataValid: any;
  botForm: UntypedFormGroup;


  constructor(public dialogRef: MatDialogRef<ManagePlaceholderComponent>,
              private botFormBuilder: UntypedFormBuilder) {
    this.botForm = this.botFormBuilder.group({
      placeholderId: new UntypedFormControl( '', [Validators.required]),
      displayName: new UntypedFormControl('', [Validators.required]),
      description: new UntypedFormControl( '', [Validators.required]),
      dataType: new UntypedFormControl('', [Validators.required]),
      minLength: new UntypedFormControl('', ),
      maxLength: new UntypedFormControl('', ),
      regularExpression: new UntypedFormControl('', ),
      hint: new UntypedFormControl('', ),
      prepopulatedValue: new UntypedFormControl('', ),
    });
  }
  private labelGroup: UntypedFormBuilder


  ngOnInit(): void {
  }

  canSaveBot() {
    return true;
    }
    saveBot() {
    throw new Error('Method not implemented.');
    }

  cancel() {
    
  }

  saveAPI() {
    
  }

  saveFlow() {

  }

  canSaveFlow() {
    return false;
  }
  setHighLight() {
    return false;
  }
  closeModal() {
    this.dialogRef.close();
  }
}
